import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { RootState } from "app/lib/store/store";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Loader from "app/components/common/Loader";
import {
  nextStep,
  prevStep,
  addStepsData,
} from "app/lib/store/slices/steps/loanTypesSteps";
import { useFetchVehicleBrands } from "app/hooks/vehicleInfo/useFetchVehicleBrands";
import MainTitle from "app/components/common/typography/MainTitle";
import ContinueButton from "app/components/common/buttons/Continue";
import PreviousButtom from "app/components/common/buttons/Previous";
import ProgressBar from "app/components/common/progressbar/ProgressBar";
import SubTitle from "app/components/common/typography/SubTitle";
import ErrorsMessage from "app/components/common/errors/ErrorsMessage";
import SearchInput from "app/components/common/inputs/SearchInput";
import NoConnection from "app/assets/icons/NoConnection";
import AddManuallyModel from "./AddManuallyModel";
import { Tooltip } from "react-tooltip";

interface FormData {
  makeId: string;
}

const SelectCarBrand: React.FC = () => {
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState<string>("");

  const { vehicleDetail, ...remaingData } = useSelector(
    (state: RootState) => state.loanTypesSteps.stepsData
  );
  const { data: brands = [], isLoading } = useFetchVehicleBrands();

  const [selected, setSelected] = useState<string>("");
  const [brandName, setbrandName] = useState<string>("");

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors },
    reset,
  } = useForm<FormData>();

  const onSubmit = (data: FormData) => {
    const { makeId } = data;
    dispatch(
      addStepsData({
        ...remaingData,
        vehicleDetail: {
          ...vehicleDetail,
          makeId: makeId,
          make: brandName,
          isCarManuallyModel: false,
        },
      })
    );

    dispatch(nextStep());
  };

  const handleLoanSelect = (type: string, name: string) => {
    if (vehicleDetail?.model) {
      dispatch(
        addStepsData({
          ...remaingData,
          vehicleDetail: {
            ...vehicleDetail,
            model: "",
          },
        })
      );
    }
    setValue("makeId", type);
    setSelected(type);
    clearErrors("makeId");
    setbrandName(name);
    // setSearchTerm(name);
  };

  const handleSearch = (searchTerm: string) => {
    setSearchTerm(searchTerm.toLowerCase());
  };

  useEffect(() => {
    if (vehicleDetail?.makeId && brands.length) {
      const brand = brands.find((b) => b.id === vehicleDetail.makeId);

      if (brand) {
        setSearchTerm(brand.name);
      }
      setSelected(vehicleDetail.makeId);
      if (vehicleDetail?.brand || (brand && brand?.name)) {
        setbrandName(vehicleDetail?.brand || brand?.name || "");
      }
      reset({
        makeId: vehicleDetail.makeId,
      });
    }
  }, [vehicleDetail, brands, reset]);

  const filteredBrands =
    searchTerm.trim() === ""
      ? []
      : brands.filter((brand) =>
          brand.name.toLowerCase().includes(searchTerm.toLowerCase())
        );

  const handleEnterManually = () => {
    dispatch(
      addStepsData({
        ...remaingData,
        vehicleDetail: {
          ...vehicleDetail,
          isCarManuallyModel: true,
        },
      })
    );
  };
  const isLongText = (text: string) => text.length > 15;

  return (
    <>
      {!vehicleDetail?.isCarManuallyModel && (
        <>
          <ProgressBar progress={20} />
          <div className="w-full  sm:w-[70%] xl:w-[50%]   mx-auto text-center px-4 sm:px-0">
            <MainTitle title="Select Car Brand" />
            <SubTitle title="Search for your preferred vehicle brand. If you're unsure, you can select from the available options." />

            <form onSubmit={handleSubmit(onSubmit)}>
              <SearchInput
                debounceTimeout={500}
                placeholder="Search Make"
                className="mt-4 lg:!w-[80%]"
                onChange={handleSearch}
                value={searchTerm}
                error={!!errors?.makeId?.message}
              />
              <div className="w-full mx-auto sm:w-[80%] md:w-[70%] lg:!w-[80%]">
                {errors.makeId && (
                  <ErrorsMessage
                    className="!text-right"
                    title={errors.makeId.message}
                  />
                )}
              </div>
              <div className="mt-6">
                {isLoading ? (
                  <Loader />
                ) : filteredBrands.length === 0 ? (
                  searchTerm.trim() === "" ? (
                    <div className="flex flex-wrap justify-center w-full my-10">
                      <NoConnection />
                      <p className="text-center text-base text-[#585C7B] w-full mt-3 font-Mulish">
                        Please search to view car brand
                      </p>
                    </div>
                  ) : (
                    <p className="text-center font-Mulish text-base text-[#585C7B] w-full mt-14">
                      couldn’t find your brand?{" "}
                      <span
                        className="text-[#D1A960] cursor-pointer"
                        onClick={handleEnterManually}
                      >
                        Enter manually
                      </span>
                    </p>
                  )
                ) : (
                  <div
                    className="
              max-h-[300px] overflow-y-auto"
                  >
                    <div className="flex flex-wrap justify-center gap-2 sm:gap-4 w-full ">
                      {filteredBrands?.map((car) => {
                        const isSelected = car.id === selected;
                        const tooltipId = `tooltip-${car.id}`;
                        const needsTooltip = isLongText(car.name);

                        return (
                          <React.Fragment>
                            <div
                              key={car.id}
                              onClick={() => handleLoanSelect(car.id, car.name)}
                              className={`w-2/5 sm:w-1/2 md:w-1/3 lg:w-[23%]  h-[80px] flex gap-4  items-center flex-col text-center border  border-gray-300  hover:shadow-cardShadow  rounded-[10px] mb-4 cursor-pointer ${
                                isSelected
                                  ? "bg-primary"
                                  : "bg-[#F5F6F7] text-[#313131]"
                              } `}
                              data-tooltip-id={tooltipId}
                              data-tooltip-content={car.name}
                            >
                              <div className="m-auto text-center">
                                <h6
                                  className={`font-Mulish text-base capitalize text-[#313131] ${
                                    isSelected ? "text-[#fff]" : ""
                                  }`}
                                >
                                  {car.name}
                                </h6>
                              </div>
                            </div>
                            {needsTooltip && (
                              <Tooltip
                                id={tooltipId}
                                place="top"
                                className="font-Mulish"
                                style={{
                                  backgroundColor: "#D1A960",
                                  color: "#fff",
                                  fontSize: "14px",
                                  padding: "8px 12px",
                                  borderRadius: "8px",
                                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                                  border: "1px solid #E5E7EB",
                                  maxWidth: "280px",
                                  fontWeight: 400,
                                  zIndex: 999,
                                }}
                              />
                            )}
                          </React.Fragment>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
              <input
                type="hidden"
                {...register("makeId", {
                  required: "Please select Brand.",
                })}
              />

              <div className="flex justify-between my-10">
                <PreviousButtom onClick={() => dispatch(prevStep())}>
                  Previous
                </PreviousButtom>
                <ContinueButton type="submit">Next</ContinueButton>
              </div>
            </form>
          </div>
        </>
      )}
      {vehicleDetail?.isCarManuallyModel && (
        <AddManuallyModel isCarBrand={true} />
      )}
    </>
  );
};

export default SelectCarBrand;
